const opportunityCreateFields = [
    { name: 'name', label: 'Opportunity Name', type: 'text', required: true },
];

export default opportunityCreateFields;
